<form [formGroup]="form">
    <mat-accordion class="w-100">
      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title>
            <b>Mappa Sopralluoghi</b>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div>
          <div class="mat-form-field margin-bottom">
            <mat-slide-toggle formControlName="enabled" color="primary">Abilitato</mat-slide-toggle>
          </div>
        </div>
        <div class="col">
          <button mat-raised-button color="primary" class="mb-2" (click)="Salva()">
              Salva
          </button>
        </div>
      </mat-expansion-panel>
    </mat-accordion>
  </form>